import DashBoardPage from "./DashBoardPage";

export default DashBoardPage